import logoWhite from "../assets/images/logo_white.png";

import "../assets/css/product.scss";

function Footer() {
  return (
    <footer class="footer">
      <div class="footer-inner">
        <h2 class="footer-title">
          {/* <img src={logoWhite} alt="" /> */}
          키즈다
        </h2>

        <div class="footer-info">
          <p>
            <strong>주식회사 위고컴퍼니</strong> | 대표: 김영기 |
            사업자등록번호: 339-87-00990
          </p>
          <p>경기도 화성시 동탄대로5길 21 4층 E420-A26호 (송동, 라크몽)</p>
          <p>대표전화: 02-3288-3455 | 청소년보호책임자: 김준영</p>
          <p>통신판매업등록번호: 2021-화성동탄-0946 | 제호: 키즈다</p>
        </div>

        <div class="footer-links">
          <a href="/application/service" target="_blank" rel="noreferrer">
            이용약관
          </a>
          <span>|</span>
          <a href="/application/privacy" target="_blank" rel="noreferrer">
            개인정보처리방침
          </a>
        </div>

        <hr class="footer-line" />

        <div class="footer-copy">Copyright © 키즈다 All rights reserved.</div>
      </div>
    </footer>
  );
}

export default Footer;
